// source: type/qualified_invoice_issuer.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.type.QualifiedInvoiceIssuer', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.QualifiedInvoiceIssuer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.QualifiedInvoiceIssuer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.QualifiedInvoiceIssuer.displayName = 'proto.type.QualifiedInvoiceIssuer';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.QualifiedInvoiceIssuer.prototype.toObject = function(opt_includeInstance) {
  return proto.type.QualifiedInvoiceIssuer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.QualifiedInvoiceIssuer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.QualifiedInvoiceIssuer.toObject = function(includeInstance, msg) {
  var f, obj = {
    issuerName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    registrationNumber: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of QualifiedInvoiceIssuer as accepted by the `fromObject` method.
 * @record
 */
proto.type.QualifiedInvoiceIssuer.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.issuerName;

  /** @type {?|undefined} */
  this.registrationNumber;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.QualifiedInvoiceIssuer.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.QualifiedInvoiceIssuer}
 */
proto.type.QualifiedInvoiceIssuer.fromObject = function(obj) {
  var msg = new proto.type.QualifiedInvoiceIssuer();
  obj.issuerName != null && jspb.Message.setField(msg, 1, obj.issuerName);
  obj.registrationNumber != null && jspb.Message.setField(msg, 2, obj.registrationNumber);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.QualifiedInvoiceIssuer}
 */
proto.type.QualifiedInvoiceIssuer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.QualifiedInvoiceIssuer;
  return proto.type.QualifiedInvoiceIssuer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.QualifiedInvoiceIssuer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.QualifiedInvoiceIssuer}
 */
proto.type.QualifiedInvoiceIssuer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIssuerName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegistrationNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.QualifiedInvoiceIssuer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.QualifiedInvoiceIssuer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.QualifiedInvoiceIssuer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.QualifiedInvoiceIssuer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssuerName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRegistrationNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string issuer_name = 1;
 * @return {string}
 */
proto.type.QualifiedInvoiceIssuer.prototype.getIssuerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.QualifiedInvoiceIssuer} returns this
 */
proto.type.QualifiedInvoiceIssuer.prototype.setIssuerName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string registration_number = 2;
 * @return {string}
 */
proto.type.QualifiedInvoiceIssuer.prototype.getRegistrationNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.QualifiedInvoiceIssuer} returns this
 */
proto.type.QualifiedInvoiceIssuer.prototype.setRegistrationNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.type);
